function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.733 6.51741L13.6193 0.272768C13.4489 0.0986608 13.2188 0 12.9773 0H0.909091C0.40625 0 0 0.414955 0 0.928571V25.0714C0 25.585 0.40625 26 0.909091 26H19.0909C19.5938 26 20 25.585 20 25.0714V7.17612C20 6.92946 19.9034 6.69152 19.733 6.51741ZM12.5568 2.14152L17.9034 7.60268H12.5568V2.14152ZM17.9545 23.9107H2.04545V2.08929H10.625V8.35714C10.625 8.68038 10.7507 8.99037 10.9745 9.21893C11.1982 9.44749 11.5017 9.57589 11.8182 9.57589H17.9545V23.9107Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9719 19.8772L16.9405 16.1038C17.0191 16.0288 17.0191 15.8905 16.9405 15.8155L12.9719 12.0444C12.948 12.0213 12.9187 12.0065 12.8875 12.0017C12.8564 11.9969 12.8246 12.0024 12.7961 12.0174C12.7676 12.0325 12.7435 12.0565 12.7267 12.0866C12.7099 12.1167 12.701 12.1517 12.7012 12.1874V13.6569C12.7012 13.7131 12.7218 13.7647 12.7611 13.7999L15.0307 15.9608L12.7611 18.1217C12.7426 18.1393 12.7277 18.1611 12.7174 18.1858C12.707 18.2105 12.7015 18.2374 12.7012 18.2647V19.7342C12.7012 19.8936 12.8645 19.9803 12.9719 19.8772Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.02805 12.1228L3.05945 15.8962C2.98091 15.9712 2.98091 16.1095 3.05945 16.1845L7.02805 19.9556C7.05201 19.9787 7.08131 19.9935 7.11247 19.9983C7.14364 20.0031 7.17536 19.9976 7.20387 19.9826C7.23238 19.9675 7.25648 19.9435 7.27331 19.9134C7.29014 19.8833 7.299 19.8483 7.29883 19.8126V18.3431C7.29883 18.2869 7.27816 18.2353 7.23888 18.2001L4.96934 16.0392L7.23888 13.8783C7.25736 13.8607 7.27228 13.8389 7.28262 13.8142C7.29297 13.7895 7.2985 13.7626 7.29883 13.7353V12.2658C7.29883 12.1064 7.13553 12.0197 7.02805 12.1228Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2607 10L7.41016 22",
  stroke: "currentColor"
});

var SvgIcHtml = function SvgIcHtml(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcHtml, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_html.45336288.svg";
export { ForwardRef as ReactComponent };